export default "<p>{{ message | async }}</p>";